
import { combineReducers } from 'redux'
import authReducer from './authReducer'
// import campaignReducer from './campaignReducer'

const reducer = combineReducers({
    // campaignReducer,
    authReducer
})

export default reducer